// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { EditorMarker } from "../../editor/v1/editor";
import { AppEntitlementReference } from "./policy_steps_approval";
import { SkippedAction } from "./shared_policy_outcomes";
import { ReassignedByErrorAction } from "./policy_steps_approval";
import { Struct } from "../../../../google/protobuf/struct";
import { Duration } from "../../../../google/protobuf/duration";
import { FormInstance } from "./policy_step_form";
import { WaitInstance } from "./policy_steps_wait";
import { ApprovalInstance } from "./policy_steps_approval";
import { Form } from "./policy_step_form";
import { Wait } from "./policy_steps_wait";
import { Approval } from "./policy_steps_approval";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * @generated from protobuf message c1.api.policy.v1.TestAccountProvisionPolicyRequest
 */
export interface TestAccountProvisionPolicyRequest {
    /**
     * @generated from protobuf field: string cel = 1;
     */
    cel: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.TestAccountProvisionPolicyResponse
 */
export interface TestAccountProvisionPolicyResponse {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ListPolicyResponse
 */
export interface ListPolicyResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.Policy list = 1;
     */
    list: Policy[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * The CreatePolicyResponse message contains the created policy object.
 *
 * @generated from protobuf message c1.api.policy.v1.CreatePolicyResponse
 */
export interface CreatePolicyResponse {
    /**
     * The new policy to create.
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1;
     */
    policy?: Policy;
}
/**
 * The CreatePolicyRequest message is used to create a new policy.
 *
 * @generated from protobuf message c1.api.policy.v1.CreatePolicyRequest
 */
export interface CreatePolicyRequest {
    /**
     * The display name of the new policy.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The description of the new policy.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * The enum of the policy type.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyType policy_type = 3;
     */
    policyType: PolicyType;
    /**
     * The map of policy type to policy steps. The key is the stringified version of the enum. See other policies for examples.
     *
     * @generated from protobuf field: map<string, c1.api.policy.v1.PolicySteps> policy_steps = 4;
     */
    policySteps: {
        [key: string]: PolicySteps;
    };
    /**
     * Actions to occur after a policy finishes. As of now this is only valid on a certify policy to remediate a denied certification immediately.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyPostActions post_actions = 5;
     */
    postActions: PolicyPostActions[];
    /**
     * Deprecated. Use setting in policy step instead
     *
     * @deprecated
     * @generated from protobuf field: bool reassignTasksToDelegates = 6 [deprecated = true];
     */
    reassignTasksToDelegates: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.Rule rules = 7;
     */
    rules: Rule[];
}
/**
 * The GetPolicyResponse message contains the policy object.
 *
 * @generated from protobuf message c1.api.policy.v1.GetPolicyResponse
 */
export interface GetPolicyResponse {
    /**
     * The policy returned by a get request.
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1;
     */
    policy?: Policy;
}
/**
 * @generated from protobuf message c1.api.policy.v1.GetPolicyRequest
 */
export interface GetPolicyRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * The UpdatePolicyResponse message contains the updated policy object.
 *
 * @generated from protobuf message c1.api.policy.v1.UpdatePolicyResponse
 */
export interface UpdatePolicyResponse {
    /**
     * The updated policy.
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1;
     */
    policy?: Policy;
}
/**
 * The UpdatePolicyRequest message contains the policy object to update and a field mask to indicate which fields to update. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.policy.v1.UpdatePolicyRequest
 */
export interface UpdatePolicyRequest {
    /**
     * The policy object with the changes to update.
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1;
     */
    policy?: Policy;
    /**
     * The update mask is a comma-sepparated string of fields to update. This may be something like "policy_type,display_name".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * The DeletePolicyRequest message contains the ID of the policy to delete. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.policy.v1.DeletePolicyRequest
 */
export interface DeletePolicyRequest {
    /**
     * The Id of the policy to delete.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.policy.v1.DeletePolicyResponse
 */
export interface DeletePolicyResponse {
}
/**
 * @generated from protobuf message c1.api.policy.v1.ListPoliciesRequest
 */
export interface ListPoliciesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * A policy instance is an object that contains a reference to the policy it was created from, the currently executing step, the next steps, and the history of previously completed steps.
 *
 * @generated from protobuf message c1.api.policy.v1.PolicyInstance
 */
export interface PolicyInstance {
    /**
     * The un-edited policy object that was included in the task when it was created.
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1;
     */
    policy?: Policy;
    /**
     * The current step being processed by the ticket.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyStepInstance current = 2;
     */
    current?: PolicyStepInstance;
    /**
     * An array of steps that will be processed by the ticket, in order.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyStep next = 3;
     */
    next: PolicyStep[];
    /**
     * An array of steps that were previously processed by the ticket with their outcomes set, in order.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyStepInstance history = 4;
     */
    history: PolicyStepInstance[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.PolicyRef
 */
export interface PolicyRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.Rule
 */
export interface Rule {
    /**
     * @generated from protobuf field: string condition = 1;
     */
    condition: string;
    /**
     * This is a reference to a list of policy steps from `policy_steps`
     *
     * @generated from protobuf field: string policy_key = 2;
     */
    policyKey: string;
}
/**
 * A policy describes the behavior of the ConductorOne system when processing a task. You can describe the type, approvers, fallback behavior, and escalation processes.
 *
 * @generated from protobuf message c1.api.policy.v1.Policy
 */
export interface Policy {
    /**
     * The ID of the Policy.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the Policy was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Policy was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Policy was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the Policy.
     *
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * The description of the Policy.
     *
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * Whether this policy is a builtin system policy. Builtin system policies cannot be edited.
     *
     * @generated from protobuf field: bool system_builtin = 7;
     */
    systemBuiltin: boolean;
    /**
     * Indicates the type of this policy. Can also be used to get the value from policySteps.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyType policy_type = 8;
     */
    policyType: PolicyType;
    /**
     * A map of string(policy type) to steps in a policy. This structure is leftover from a previous design, and should only ever have one key->value set.
     *
     * @generated from protobuf field: map<string, c1.api.policy.v1.PolicySteps> policy_steps = 9;
     */
    policySteps: {
        [key: string]: PolicySteps;
    };
    /**
     * An array of actions (ordered) to take place after a policy completes processing.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyPostActions post_actions = 10;
     */
    postActions: PolicyPostActions[];
    /**
     * Deprecated. Use setting in policy step instead
     *
     * @deprecated
     * @generated from protobuf field: bool reassign_tasks_to_delegates = 11 [deprecated = true];
     */
    reassignTasksToDelegates: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.Rule rules = 12;
     */
    rules: Rule[];
}
/**
 * These are actions to happen after a policy is complete.
 *
 * @generated from protobuf message c1.api.policy.v1.PolicyPostActions
 */
export interface PolicyPostActions {
    /**
     * @generated from protobuf oneof: action
     */
    action: {
        oneofKind: "certifyRemediateImmediately";
        /**
         * ONLY valid when used in a CERTIFY Ticket Type:
         * Causes any deprovision or change in a grant to be applied when Certify Ticket is closed.
         *
         * @generated from protobuf field: bool certify_remediate_immediately = 100;
         */
        certifyRemediateImmediately: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.PolicySteps
 */
export interface PolicySteps {
    /**
     * An array of policy steps indicating the processing flow of a policy. These steps are oneOfs, and only one property may be set for each array index at a time.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyStep steps = 1;
     */
    steps: PolicyStep[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.PolicyStep
 */
export interface PolicyStep {
    /**
     * @generated from protobuf oneof: step
     */
    step: {
        oneofKind: "approval";
        /**
         * An approval policy step.
         *
         * @generated from protobuf field: c1.api.policy.v1.Approval approval = 100;
         */
        approval: Approval;
    } | {
        oneofKind: "provision";
        /**
         * A provision policy step.
         *
         * @generated from protobuf field: c1.api.policy.v1.Provision provision = 104;
         */
        provision: Provision;
    } | {
        oneofKind: "accept";
        /**
         * A policy step that indicates that a ticket should be accepted.
         *
         * @generated from protobuf field: c1.api.policy.v1.Accept accept = 105;
         */
        accept: Accept;
    } | {
        oneofKind: "reject";
        /**
         * A policy step that indicates that a ticket should be rejected.
         *
         * @generated from protobuf field: c1.api.policy.v1.Reject reject = 106;
         */
        reject: Reject;
    } | {
        oneofKind: "wait";
        /**
         * A policy step that a ticket waits on before continuing.
         *
         * @generated from protobuf field: c1.api.policy.v1.Wait wait = 107;
         */
        wait: Wait;
    } | {
        oneofKind: "form";
        /**
         * A policy step that indicates that a ticket should have a form.
         *
         * @generated from protobuf field: c1.api.policy.v1.Form form = 108;
         */
        form: Form;
    } | {
        oneofKind: "action";
        /**
         * A policy step that indicates that an action should be executed.
         *
         * @generated from protobuf field: c1.api.policy.v1.Action action = 109;
         */
        action: Action;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The policy step instance includes a reference to an instance of a policy step that tracks state and has a unique ID.
 *
 * @generated from protobuf message c1.api.policy.v1.PolicyStepInstance
 */
export interface PolicyStepInstance {
    /**
     * The state of the step, which is either active or done.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyStepState state = 1;
     */
    state: PolicyStepState;
    /**
     * The ID of the PolicyStepInstance. This is required by many action submission endpoints to indicate what step you're approving.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf oneof: instance
     */
    instance: {
        oneofKind: "approval";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is an Approval step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ApprovalInstance approval = 100;
         */
        approval: ApprovalInstance;
    } | {
        oneofKind: "provision";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is a Provision step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ProvisionInstance provision = 103;
         */
        provision: ProvisionInstance;
    } | {
        oneofKind: "accept";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is an Accept step.
         *
         * @generated from protobuf field: c1.api.policy.v1.AcceptInstance accept = 104;
         */
        accept: AcceptInstance;
    } | {
        oneofKind: "reject";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is a Reject step.
         *
         * @generated from protobuf field: c1.api.policy.v1.RejectInstance reject = 105;
         */
        reject: RejectInstance;
    } | {
        oneofKind: "wait";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is a Wait step.
         *
         * @generated from protobuf field: c1.api.policy.v1.WaitInstance wait = 106;
         */
        wait: WaitInstance;
    } | {
        oneofKind: "form";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is a Form step.
         *
         * @generated from protobuf field: c1.api.policy.v1.FormInstance form = 107;
         */
        form: FormInstance;
    } | {
        oneofKind: "action";
        /**
         * Part of the instance oneOf, indicating that this PolicyStepInstance is an Action step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionInstance action = 108;
         */
        action: ActionInstance;
    } | {
        oneofKind: undefined;
    };
    /**
     * The policy generation id refers to the version of the policy that this step was created from.
     *
     * @generated from protobuf field: string policy_generation_id = 3;
     */
    policyGenerationId: string;
}
/**
 * The provision step references a provision policy for this step.
 *
 * @generated from protobuf message c1.api.policy.v1.Provision
 */
export interface Provision {
    /**
     * A field indicating whether this step is assigned.
     *
     * @generated from protobuf field: bool assigned = 1;
     */
    assigned: boolean;
    /**
     * A provision policy indicated by this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy provision_policy = 2;
     */
    provisionPolicy?: ProvisionPolicy;
    /**
     * A provision target indicated by this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionTarget provision_target = 3;
     */
    provisionTarget?: ProvisionTarget;
}
/**
 * @generated from protobuf message c1.api.policy.v1.Action
 */
export interface Action {
    /**
     * @generated from protobuf oneof: target
     */
    target: {
        oneofKind: "automation";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ActionTargetAutomation automation = 100;
         */
        automation: ActionTargetAutomation;
    } | {
        oneofKind: "batonResourceAction";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ActionTargetBatonResourceAction baton_resource_action = 101;
         */
        batonResourceAction: ActionTargetBatonResourceAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ActionTargetAutomation targets automation templates for policy actions.
 *
 * @generated from protobuf message c1.api.policy.v1.ActionTargetAutomation
 */
export interface ActionTargetAutomation {
    /**
     * @generated from protobuf field: string automation_template_id = 1;
     */
    automationTemplateId: string;
}
/**
 * ActionTargetResource targets resource actions for policy actions.
 *
 * @generated from protobuf message c1.api.policy.v1.ActionTargetBatonResourceAction
 */
export interface ActionTargetBatonResourceAction {
    /**
     * @generated from protobuf field: string baton_resource_action_id = 1;
     */
    batonResourceActionId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionInstance
 */
export interface ActionInstance {
    /**
     * The action configuration for this instance.
     *
     * @generated from protobuf field: c1.api.policy.v1.Action action = 1;
     */
    action?: Action;
    /**
     * The current state of the action execution.
     *
     * @generated from protobuf field: c1.api.policy.v1.ActionInstanceState state = 2;
     */
    state: ActionInstanceState;
    /**
     * @generated from protobuf oneof: target_instance
     */
    targetInstance: {
        oneofKind: "automation";
        /**
         * The automation execution instance details.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionTargetAutomationInstance automation = 100;
         */
        automation: ActionTargetAutomationInstance;
    } | {
        oneofKind: "batonResourceActionInstance";
        /**
         * The baton resource action instance details.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionTargetBatonResourceActionInstance baton_resource_action_instance = 101;
         */
        batonResourceActionInstance: ActionTargetBatonResourceActionInstance;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "success";
        /**
         * The action completed successfully.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionOutcomeSuccess success = 200;
         */
        success: ActionOutcomeSuccess;
    } | {
        oneofKind: "denied";
        /**
         * The action was denied.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionOutcomeDenied denied = 201;
         */
        denied: ActionOutcomeDenied;
    } | {
        oneofKind: "error";
        /**
         * The action failed with an error.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionOutcomeError error = 202;
         */
        error: ActionOutcomeError;
    } | {
        oneofKind: "cancelled";
        /**
         * The action was cancelled.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionOutcomeCancelled cancelled = 203;
         */
        cancelled: ActionOutcomeCancelled;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionOutcomeSuccess
 */
export interface ActionOutcomeSuccess {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 1;
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionOutcomeDenied
 */
export interface ActionOutcomeDenied {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 1;
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionOutcomeError
 */
export interface ActionOutcomeError {
    /**
     * @generated from protobuf field: string error_code = 1;
     */
    errorCode: string;
    /**
     * @generated from protobuf field: string error_message = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 3;
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionOutcomeCancelled
 */
export interface ActionOutcomeCancelled {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 1;
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionTargetAutomationInstance
 */
export interface ActionTargetAutomationInstance {
    /**
     * @generated from protobuf field: string automation_execution_id = 1;
     */
    automationExecutionId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ActionTargetBatonResourceActionInstance
 */
export interface ActionTargetBatonResourceActionInstance {
    /**
     * @generated from protobuf field: string baton_action_invocation_id = 1;
     */
    batonActionInvocationId: string;
}
/**
 * ProvisionPolicy is a oneOf that indicates how a provision step should be processed.
 *
 * @generated from protobuf message c1.api.policy.v1.ProvisionPolicy
 */
export interface ProvisionPolicy {
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "connector";
        /**
         * Part of the typ oneOf, indicating that a connector should provision this entitlement.
         *
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision connector = 100;
         */
        connector: ConnectorProvision;
    } | {
        oneofKind: "manual";
        /**
         * Part of the typ oneOf, indicating that a human must manually intervene during this provision step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ManualProvision manual = 101;
         */
        manual: ManualProvision;
    } | {
        oneofKind: "delegated";
        /**
         * Part of the typ oneOf, indicating that we should delegate provisioning to another entitlement for this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.DelegatedProvision delegated = 102;
         */
        delegated: DelegatedProvision;
    } | {
        oneofKind: "webhook";
        /**
         * Part of the typ oneOf, indicating that a webhook should be called to provision this entitlement.
         *
         * @generated from protobuf field: c1.api.policy.v1.WebhookProvision webhook = 103;
         */
        webhook: WebhookProvision;
    } | {
        oneofKind: "multiStep";
        /**
         * Part of the typ oneOf, indicating that this provision policy actually has multiple steps
         *
         * @generated from protobuf field: c1.api.policy.v1.MultiStep multi_step = 104;
         */
        multiStep: MultiStep;
    } | {
        oneofKind: "externalTicket";
        /**
         * Part of the typ oneOf, indicating that an external ticket integration should be called to provision this entitlement.
         *
         * @generated from protobuf field: c1.api.policy.v1.ExternalTicketProvision external_ticket = 105;
         */
        externalTicket: ExternalTicketProvision;
    } | {
        oneofKind: "unconfigured";
        /**
         * Part of the typ oneOf, indicating that this provision policy is unconfigured.
         *
         * @generated from protobuf field: c1.api.policy.v1.UnconfiguredProvision unconfigured = 106;
         */
        unconfigured: UnconfiguredProvision;
    } | {
        oneofKind: "action";
        /**
         * Part of the typ oneOf, indicating that account lifecycle action should be called to provision this entitlement.
         *
         * @generated from protobuf field: c1.api.policy.v1.ActionProvision action = 107;
         */
        action: ActionProvision;
    } | {
        oneofKind: undefined;
    };
}
/**
 * MultiStep indicates that this provision step has multiple steps to process.
 *
 * @generated from protobuf message c1.api.policy.v1.MultiStep
 */
export interface MultiStep {
    /**
     * The array of provision steps to process.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.ProvisionPolicy provision_steps = 1;
     */
    provisionSteps: ProvisionPolicy[];
}
/**
 * ProvisionTarget indicates the specific app, app entitlement, and if known, the app user and grant duration of this provision step
 *
 * @generated from protobuf message c1.api.policy.v1.ProvisionTarget
 */
export interface ProvisionTarget {
    /**
     * The app in which the entitlement should be provisioned
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The app user that should be provisioned. May be unset if the app user is unknown
     *
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * The app entitlement that should be provisioned.
     *
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * The grant duration being provisioned, if set
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 4;
     */
    grantDuration?: Duration;
}
/**
 * Indicates that a connector should perform the provisioning. This object has no fields.
 *
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision
 */
export interface ConnectorProvision {
    /**
     * @generated from protobuf oneof: provision_type
     */
    provisionType: {
        oneofKind: "defaultBehavior";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision.DefaultBehavior default_behavior = 1;
         */
        defaultBehavior: ConnectorProvision_DefaultBehavior;
    } | {
        oneofKind: "account";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision.AccountProvision account = 2;
         */
        account: ConnectorProvision_AccountProvision;
    } | {
        oneofKind: "deleteAccount";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision.DeleteAccount delete_account = 3;
         */
        deleteAccount: ConnectorProvision_DeleteAccount;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision.DefaultBehavior
 */
export interface ConnectorProvision_DefaultBehavior {
    /**
     * this checks if the entitlement is enabled by provisioning in a specific connector
     * this can happen automatically and doesn't need any extra info
     *
     * @generated from protobuf field: string connector_id = 1;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision.DeleteAccount
 */
export interface ConnectorProvision_DeleteAccount {
    /**
     * @generated from protobuf field: string connector_id = 1;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision.AccountProvision
 */
export interface ConnectorProvision_AccountProvision {
    /**
     * @generated from protobuf field: string connector_id = 1;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string schema_id = 2;
     */
    schemaId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct config = 3;
     */
    config?: Struct;
    /**
     * @generated from protobuf oneof: storage_type
     */
    storageType: {
        oneofKind: "saveToVault";
        /**
         * Indicates that the password should be saved to a vault.
         *
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision.SaveToVault save_to_vault = 4;
         */
        saveToVault: ConnectorProvision_SaveToVault;
    } | {
        oneofKind: "doNotSave";
        /**
         * Indicates that the password will not be saved anywhere.
         *
         * @generated from protobuf field: c1.api.policy.v1.ConnectorProvision.DoNotSave do_not_save = 5;
         */
        doNotSave: ConnectorProvision_DoNotSave;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision.SaveToVault
 */
export interface ConnectorProvision_SaveToVault {
    /**
     * @generated from protobuf field: repeated string vault_ids = 1;
     */
    vaultIds: string[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.ConnectorProvision.DoNotSave
 */
export interface ConnectorProvision_DoNotSave {
}
/**
 * Manual provisioning indicates that a human must intervene for the provisioning of this step.
 *
 * @generated from protobuf message c1.api.policy.v1.ManualProvision
 */
export interface ManualProvision {
    /**
     * This field indicates a text body of instructions for the provisioner to indicate.
     *
     * @generated from protobuf field: string instructions = 1;
     */
    instructions: string;
    /**
     * An array of users that are required to provision during this step.
     *
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * This provision step indicates that we should delegate provisioning to the configuration of another app entitlement. This app entitlement does not have to be one from the same app, but MUST be configured as a proxy binding leading into this entitlement.
 *
 * @generated from protobuf message c1.api.policy.v1.DelegatedProvision
 */
export interface DelegatedProvision {
    /**
     * The AppID of the entitlement to delegate provisioning to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the entitlement we are delegating provisioning to.
     *
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * If true, a binding will be automatically created from the entitlement of the parent app.
     *
     * @generated from protobuf field: bool implicit = 3;
     */
    implicit: boolean;
}
/**
 * This provision step indicates that a webhook should be called to provision this entitlement.
 *
 * @generated from protobuf message c1.api.policy.v1.WebhookProvision
 */
export interface WebhookProvision {
    /**
     * The ID of the webhook to call for provisioning.
     *
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
}
/**
 * This provision step indicates that we should check an external ticket to provision this entitlement
 *
 * @generated from protobuf message c1.api.policy.v1.ExternalTicketProvision
 */
export interface ExternalTicketProvision {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * This field indicates a text body of instructions for the provisioner to indicate.
     *
     * @generated from protobuf field: string instructions = 4;
     */
    instructions: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.UnconfiguredProvision
 */
export interface UnconfiguredProvision {
}
/**
 * This provision step indicates that account lifecycle action should be called to provision this entitlement.
 *
 * @generated from protobuf message c1.api.policy.v1.ActionProvision
 */
export interface ActionProvision {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string action_name = 3;
     */
    actionName: string;
    /**
     * @generated from protobuf field: string display_name = 4;
     */
    displayName: string;
}
/**
 * This policy step indicates that a ticket should have an approved outcome. This is a terminal approval state and is used to explicitly define the end of approval steps.
 *
 * @generated from protobuf message c1.api.policy.v1.Accept
 */
export interface Accept {
    /**
     * An optional message to include in the comments when a task is automatically accepted.
     *
     * @generated from protobuf field: string accept_message = 1;
     */
    acceptMessage: string;
}
/**
 * This policy step indicates that a ticket should have a denied outcome. This is a terminal approval state and is used to explicitly define the end of approval steps.
 *
 * @generated from protobuf message c1.api.policy.v1.Reject
 */
export interface Reject {
    /**
     * An optional message to include in the comments when a task is automatically rejected.
     *
     * @generated from protobuf field: string reject_message = 1;
     */
    rejectMessage: string;
}
/**
 * Search Policies by a few properties.
 *
 * @generated from protobuf message c1.api.policy.v1.SearchPoliciesRequest
 */
export interface SearchPoliciesRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the policies with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * The policy type to search on. This can be POLICY_TYPE_GRANT, POLICY_TYPE_REVOKE, POLICY_TYPE_CERTIFY, POLICY_TYPE_ACCESS_REQUEST, or POLICY_TYPE_PROVISION.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyType policy_types = 4;
     */
    policyTypes: PolicyType[];
    /**
     * Search for policies with a case insensitive match on the display name.
     *
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef refs = 6;
     */
    refs: PolicyRef[];
    /**
     * @generated from protobuf field: bool include_deleted = 7;
     */
    includeDeleted: boolean;
    /**
     * The policy IDs to exclude from the search.
     *
     * @generated from protobuf field: repeated string exclude_policy_ids = 8;
     */
    excludePolicyIds: string[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.SearchPoliciesResponse
 */
export interface SearchPoliciesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.Policy list = 1;
     */
    list: Policy[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.CountUsedByRequest
 */
export interface CountUsedByRequest {
    /**
     * @generated from protobuf field: string policy_id = 1;
     */
    policyId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.CountUsedByResponse
 */
export interface CountUsedByResponse {
    /**
     * @generated from protobuf field: int64 count_apps = 1;
     */
    countApps: number;
    /**
     * @generated from protobuf field: int64 count_app_entitlements = 2;
     */
    countAppEntitlements: number;
    /**
     * @generated from protobuf field: int64 count_campaigns = 3;
     */
    countCampaigns: number;
    /**
     * @generated from protobuf field: int64 count_campaign_templates = 4;
     */
    countCampaignTemplates: number;
}
/**
 * A provision instance describes the specific configuration of an executing provision policy step including actions taken and notification id.
 *
 * @generated from protobuf message c1.api.policy.v1.ProvisionInstance
 */
export interface ProvisionInstance {
    /**
     * The provision property references the configuration used for provisioning this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.Provision provision = 1;
     */
    provision?: Provision;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "completed";
        /**
         * This provision outcome indicates that the step was completed successfully.
         *
         * @generated from protobuf field: c1.api.policy.v1.CompletedAction completed = 100;
         */
        completed: CompletedAction;
    } | {
        oneofKind: "cancelled";
        /**
         * This provision outcome indicates that the step was cancelled.
         *
         * @generated from protobuf field: c1.api.policy.v1.CancelledAction cancelled = 101;
         */
        cancelled: CancelledAction;
    } | {
        oneofKind: "errored";
        /**
         * This provision outcome indicates that the step had an error while provisioning.
         *
         * @generated from protobuf field: c1.api.policy.v1.ErroredAction errored = 102;
         */
        errored: ErroredAction;
    } | {
        oneofKind: "reassignedByError";
        /**
         * This provision outcome indicates that the step was reassigned due to an error.
         *
         * @generated from protobuf field: c1.api.policy.v1.ReassignedByErrorAction reassigned_by_error = 103;
         */
        reassignedByError: ReassignedByErrorAction;
    } | {
        oneofKind: "skipped";
        /**
         * This provision outcome indicates that the step was skipped.
         *
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 104;
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
    /**
     * This property indicates the current state of this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionInstanceState state = 2;
     */
    state: ProvisionInstanceState;
    /**
     * This indicates the notification id for this step.
     *
     * @generated from protobuf field: string notification_id = 3;
     */
    notificationId: string;
    /**
     * This indicates the webhook id for this step.
     *
     * @generated from protobuf field: string webhook_id = 4;
     */
    webhookId: string;
    /**
     * This indicates the webhook instance id for this step.
     *
     * @generated from protobuf field: string webhook_instance_id = 5;
     */
    webhookInstanceId: string;
    /**
     * This indicates the external ticket provisioner config id for this step.
     *
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 6;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * This indicates the external ticket id for this step.
     *
     * @generated from protobuf field: string external_ticket_id = 7;
     */
    externalTicketId: string;
    /**
     * This indicates the account lifecycle action id for this step.
     *
     * @generated from protobuf field: string baton_action_invocation_id = 8;
     */
    batonActionInvocationId: string;
}
/**
 * The outcome of a provision instance that has been completed succesfully.
 *
 * @generated from protobuf message c1.api.policy.v1.CompletedAction
 */
export interface CompletedAction {
    /**
     * The UserID of who completed provisioning. For connector provisioning this is the system user id, for manual provisioning this is who clicked "provision complete"
     *
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * The list of entitlements that were provisioned. This is leftover from an older design, and is only ever going to be a single entitlement.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference entitlements = 2;
     */
    entitlements: AppEntitlementReference[];
    /**
     * The time that the provision instance was completed at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 3;
     */
    completedAt?: Timestamp;
}
/**
 * The outcome of a provision instance that is cancelled.
 *
 * @generated from protobuf message c1.api.policy.v1.CancelledAction
 */
export interface CancelledAction {
    /**
     * The userID, usually the system, that cancells a provision instance.
     *
     * @generated from protobuf field: string cancelled_by_user_id = 1;
     */
    cancelledByUserId: string;
    /**
     * The time that the provision instance is cancelled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp cancelled_at = 2;
     */
    cancelledAt?: Timestamp;
}
/**
 * The outcome of a provision instance that has errored.
 *
 * @generated from protobuf message c1.api.policy.v1.ErroredAction
 */
export interface ErroredAction {
    /**
     * The error code of a provision instance that has errored. This is only PEC-1 for now, but more will be added in the future.
     *
     * @generated from protobuf field: string error_code = 1;
     */
    errorCode: string;
    /**
     * The description of a provision instance that has errored.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * The RFC3339 formatted timestamp of when the error occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp errored_at = 3;
     */
    erroredAt?: Timestamp;
}
/**
 * This policy step indicates that a ticket should have an approved outcome. This is a terminal approval state and is used to explicitly define the end of approval steps.
 * The instance is just a marker for it being copied into an active policy.
 *
 * @generated from protobuf message c1.api.policy.v1.AcceptInstance
 */
export interface AcceptInstance {
    /**
     * An optional message to include in the comments when a task is automatically accepted.
     *
     * @generated from protobuf field: string accept_message = 1;
     */
    acceptMessage: string;
}
/**
 * This policy step indicates that a ticket should have a denied outcome. This is a terminal approval state and is used to explicitly define the end of approval steps.
 * The instance is just a marker for it being copied into an active policy.
 *
 * @generated from protobuf message c1.api.policy.v1.RejectInstance
 */
export interface RejectInstance {
    /**
     * An optional message to include in the comments when a task is automatically rejected.
     *
     * @generated from protobuf field: string reject_message = 1;
     */
    rejectMessage: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.EditorValidateRequest
 */
export interface EditorValidateRequest {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.EditorValidateResponse
 */
export interface EditorValidateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.editor.v1.EditorMarker markers = 1;
     */
    markers: EditorMarker[];
}
/**
 * @generated from protobuf enum c1.api.policy.v1.PolicyType
 */
export enum PolicyType {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: POLICY_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Indicates a grant policy.
     *
     * @generated from protobuf enum value: POLICY_TYPE_GRANT = 1;
     */
    GRANT = 1,
    /**
     * Indicates a revoke policy.
     *
     * @generated from protobuf enum value: POLICY_TYPE_REVOKE = 2;
     */
    REVOKE = 2,
    /**
     * Indicates a certify policy.
     *
     * @generated from protobuf enum value: POLICY_TYPE_CERTIFY = 3;
     */
    CERTIFY = 3,
    /**
     * @deprecated
     * @generated from protobuf enum value: POLICY_TYPE_ACCESS_REQUEST = 4 [deprecated = true];
     */
    ACCESS_REQUEST = 4,
    /**
     * Indicates a provision policy. These are set as indivial steps on entitlements and are not to be configured as top-level objects. This value can only be set internally.
     *
     * @generated from protobuf enum value: POLICY_TYPE_PROVISION = 5;
     */
    PROVISION = 5
}
/**
 * @generated from protobuf enum c1.api.policy.v1.PolicyStepState
 */
export enum PolicyStepState {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: POLICY_STEP_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The policy step is being worked on.
     *
     * @generated from protobuf enum value: POLICY_STEP_STATE_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * The policy step is done being worked on.
     *
     * @generated from protobuf enum value: POLICY_STEP_STATE_DONE = 2;
     */
    DONE = 2
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ActionOutcome
 */
export enum ActionOutcome {
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ActionInstanceState
 */
export enum ActionInstanceState {
    /**
     * @generated from protobuf enum value: ACTION_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACTION_INSTANCE_STATE_INIT = 1;
     */
    INIT = 1,
    /**
     * @generated from protobuf enum value: ACTION_INSTANCE_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: ACTION_INSTANCE_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: ACTION_INSTANCE_STATE_ERROR = 4;
     */
    ERROR = 4
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ProvisionInstanceState
 */
export enum ProvisionInstanceState {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The provision instance is initializing.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_INIT = 1;
     */
    INIT = 1,
    /**
     * The provision instance is creating connector actions.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_CREATE_CONNECTOR_ACTIONS_FOR_TARGET = 5;
     */
    CREATE_CONNECTOR_ACTIONS_FOR_TARGET = 5,
    /**
     * The provision instance is sending notifications.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_SENDING_NOTIFICATIONS = 2;
     */
    SENDING_NOTIFICATIONS = 2,
    /**
     * The provision instance is waiting for the connector or a human to report a provision outcome.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_WAITING = 3;
     */
    WAITING = 3,
    /**
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_WEBHOOK = 6;
     */
    WEBHOOK = 6,
    /**
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_WEBHOOK_WAITING = 7;
     */
    WEBHOOK_WAITING = 7,
    /**
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_EXTERNAL_TICKET = 8;
     */
    EXTERNAL_TICKET = 8,
    /**
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_EXTERNAL_TICKET_WAITING = 9;
     */
    EXTERNAL_TICKET_WAITING = 9,
    /**
     * The provision instance is calling account lifecycle actions.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_ACCOUNT_LIFECYCLE_ACTIONS = 10;
     */
    ACCOUNT_LIFECYCLE_ACTIONS = 10,
    /**
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_ACCOUNT_LIFECYCLE_ACTIONS_WAITING = 11;
     */
    ACCOUNT_LIFECYCLE_ACTIONS_WAITING = 11,
    /**
     * The provision instance is done processing.
     *
     * @generated from protobuf enum value: PROVISION_INSTANCE_STATE_DONE = 4;
     */
    DONE = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class TestAccountProvisionPolicyRequest$Type extends MessageType<TestAccountProvisionPolicyRequest> {
    constructor() {
        super("c1.api.policy.v1.TestAccountProvisionPolicyRequest", [
            { no: 1, name: "cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.TestAccountProvisionPolicyRequest
 */
export const TestAccountProvisionPolicyRequest = new TestAccountProvisionPolicyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestAccountProvisionPolicyResponse$Type extends MessageType<TestAccountProvisionPolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.TestAccountProvisionPolicyResponse", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.TestAccountProvisionPolicyResponse
 */
export const TestAccountProvisionPolicyResponse = new TestAccountProvisionPolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPolicyResponse$Type extends MessageType<ListPolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.ListPolicyResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Policy },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ListPolicyResponse
 */
export const ListPolicyResponse = new ListPolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePolicyResponse$Type extends MessageType<CreatePolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.CreatePolicyResponse", [
            { no: 1, name: "policy", kind: "message", T: () => Policy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CreatePolicyResponse
 */
export const CreatePolicyResponse = new CreatePolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePolicyRequest$Type extends MessageType<CreatePolicyRequest> {
    constructor() {
        super("c1.api.policy.v1.CreatePolicyRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_type", kind: "enum", T: () => ["c1.api.policy.v1.PolicyType", PolicyType, "POLICY_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "policy_steps", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PolicySteps } },
            { no: 5, name: "post_actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyPostActions },
            { no: 6, name: "reassignTasksToDelegates", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Rule }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Policy" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CreatePolicyRequest
 */
export const CreatePolicyRequest = new CreatePolicyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPolicyResponse$Type extends MessageType<GetPolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.GetPolicyResponse", [
            { no: 1, name: "policy", kind: "message", T: () => Policy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.GetPolicyResponse
 */
export const GetPolicyResponse = new GetPolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPolicyRequest$Type extends MessageType<GetPolicyRequest> {
    constructor() {
        super("c1.api.policy.v1.GetPolicyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.GetPolicyRequest
 */
export const GetPolicyRequest = new GetPolicyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePolicyResponse$Type extends MessageType<UpdatePolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.UpdatePolicyResponse", [
            { no: 1, name: "policy", kind: "message", T: () => Policy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.UpdatePolicyResponse
 */
export const UpdatePolicyResponse = new UpdatePolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePolicyRequest$Type extends MessageType<UpdatePolicyRequest> {
    constructor() {
        super("c1.api.policy.v1.UpdatePolicyRequest", [
            { no: 1, name: "policy", kind: "message", T: () => Policy },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.UpdatePolicyRequest
 */
export const UpdatePolicyRequest = new UpdatePolicyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePolicyRequest$Type extends MessageType<DeletePolicyRequest> {
    constructor() {
        super("c1.api.policy.v1.DeletePolicyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Policy" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.DeletePolicyRequest
 */
export const DeletePolicyRequest = new DeletePolicyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePolicyResponse$Type extends MessageType<DeletePolicyResponse> {
    constructor() {
        super("c1.api.policy.v1.DeletePolicyResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.DeletePolicyResponse
 */
export const DeletePolicyResponse = new DeletePolicyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPoliciesRequest$Type extends MessageType<ListPoliciesRequest> {
    constructor() {
        super("c1.api.policy.v1.ListPoliciesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ListPoliciesRequest
 */
export const ListPoliciesRequest = new ListPoliciesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicyInstance$Type extends MessageType<PolicyInstance> {
    constructor() {
        super("c1.api.policy.v1.PolicyInstance", [
            { no: 1, name: "policy", kind: "message", T: () => Policy, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "current", kind: "message", T: () => PolicyStepInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "next", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyStep, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyStepInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicyInstance
 */
export const PolicyInstance = new PolicyInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicyRef$Type extends MessageType<PolicyRef> {
    constructor() {
        super("c1.api.policy.v1.PolicyRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicyRef
 */
export const PolicyRef = new PolicyRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Rule$Type extends MessageType<Rule> {
    constructor() {
        super("c1.api.policy.v1.Rule", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "policy_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Rule
 */
export const Rule = new Rule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Policy$Type extends MessageType<Policy> {
    constructor() {
        super("c1.api.policy.v1.Policy", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "512" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "2048" } } } },
            { no: 7, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "policy_type", kind: "enum", T: () => ["c1.api.policy.v1.PolicyType", PolicyType, "POLICY_TYPE_"] },
            { no: 9, name: "policy_steps", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PolicySteps } },
            { no: 10, name: "post_actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyPostActions },
            { no: 11, name: "reassign_tasks_to_delegates", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Rule }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Policy" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Policy
 */
export const Policy = new Policy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicyPostActions$Type extends MessageType<PolicyPostActions> {
    constructor() {
        super("c1.api.policy.v1.PolicyPostActions", [
            { no: 100, name: "certify_remediate_immediately", kind: "scalar", oneof: "action", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicyPostActions
 */
export const PolicyPostActions = new PolicyPostActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicySteps$Type extends MessageType<PolicySteps> {
    constructor() {
        super("c1.api.policy.v1.PolicySteps", [
            { no: 1, name: "steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyStep, options: { "validate.rules": { repeated: { minItems: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicySteps
 */
export const PolicySteps = new PolicySteps$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicyStep$Type extends MessageType<PolicyStep> {
    constructor() {
        super("c1.api.policy.v1.PolicyStep", [
            { no: 100, name: "approval", kind: "message", oneof: "step", T: () => Approval },
            { no: 104, name: "provision", kind: "message", oneof: "step", T: () => Provision, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 105, name: "accept", kind: "message", oneof: "step", T: () => Accept },
            { no: 106, name: "reject", kind: "message", oneof: "step", T: () => Reject },
            { no: 107, name: "wait", kind: "message", oneof: "step", T: () => Wait },
            { no: 108, name: "form", kind: "message", oneof: "step", T: () => Form },
            { no: 109, name: "action", kind: "message", oneof: "step", T: () => Action }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicyStep
 */
export const PolicyStep = new PolicyStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PolicyStepInstance$Type extends MessageType<PolicyStepInstance> {
    constructor() {
        super("c1.api.policy.v1.PolicyStepInstance", [
            { no: 1, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.PolicyStepState", PolicyStepState, "POLICY_STEP_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 100, name: "approval", kind: "message", oneof: "instance", T: () => ApprovalInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 103, name: "provision", kind: "message", oneof: "instance", T: () => ProvisionInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 104, name: "accept", kind: "message", oneof: "instance", T: () => AcceptInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 105, name: "reject", kind: "message", oneof: "instance", T: () => RejectInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 106, name: "wait", kind: "message", oneof: "instance", T: () => WaitInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 107, name: "form", kind: "message", oneof: "instance", T: () => FormInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 108, name: "action", kind: "message", oneof: "instance", T: () => ActionInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "policy_generation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.PolicyStepInstance
 */
export const PolicyStepInstance = new PolicyStepInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Provision$Type extends MessageType<Provision> {
    constructor() {
        super("c1.api.policy.v1.Provision", [
            { no: 1, name: "assigned", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "provision_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 3, name: "provision_target", kind: "message", T: () => ProvisionTarget }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Provision
 */
export const Provision = new Provision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
    constructor() {
        super("c1.api.policy.v1.Action", [
            { no: 100, name: "automation", kind: "message", oneof: "target", T: () => ActionTargetAutomation },
            { no: 101, name: "baton_resource_action", kind: "message", oneof: "target", T: () => ActionTargetBatonResourceAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetAutomation$Type extends MessageType<ActionTargetAutomation> {
    constructor() {
        super("c1.api.policy.v1.ActionTargetAutomation", [
            { no: 1, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionTargetAutomation
 */
export const ActionTargetAutomation = new ActionTargetAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetBatonResourceAction$Type extends MessageType<ActionTargetBatonResourceAction> {
    constructor() {
        super("c1.api.policy.v1.ActionTargetBatonResourceAction", [
            { no: 1, name: "baton_resource_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionTargetBatonResourceAction
 */
export const ActionTargetBatonResourceAction = new ActionTargetBatonResourceAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionInstance$Type extends MessageType<ActionInstance> {
    constructor() {
        super("c1.api.policy.v1.ActionInstance", [
            { no: 1, name: "action", kind: "message", T: () => Action },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.ActionInstanceState", ActionInstanceState, "ACTION_INSTANCE_STATE_"] },
            { no: 100, name: "automation", kind: "message", oneof: "targetInstance", T: () => ActionTargetAutomationInstance },
            { no: 101, name: "baton_resource_action_instance", kind: "message", oneof: "targetInstance", T: () => ActionTargetBatonResourceActionInstance },
            { no: 200, name: "success", kind: "message", oneof: "outcome", T: () => ActionOutcomeSuccess },
            { no: 201, name: "denied", kind: "message", oneof: "outcome", T: () => ActionOutcomeDenied },
            { no: 202, name: "error", kind: "message", oneof: "outcome", T: () => ActionOutcomeError },
            { no: 203, name: "cancelled", kind: "message", oneof: "outcome", T: () => ActionOutcomeCancelled }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionInstance
 */
export const ActionInstance = new ActionInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionOutcomeSuccess$Type extends MessageType<ActionOutcomeSuccess> {
    constructor() {
        super("c1.api.policy.v1.ActionOutcomeSuccess", [
            { no: 1, name: "outcome_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionOutcomeSuccess
 */
export const ActionOutcomeSuccess = new ActionOutcomeSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionOutcomeDenied$Type extends MessageType<ActionOutcomeDenied> {
    constructor() {
        super("c1.api.policy.v1.ActionOutcomeDenied", [
            { no: 1, name: "outcome_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionOutcomeDenied
 */
export const ActionOutcomeDenied = new ActionOutcomeDenied$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionOutcomeError$Type extends MessageType<ActionOutcomeError> {
    constructor() {
        super("c1.api.policy.v1.ActionOutcomeError", [
            { no: 1, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "outcome_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionOutcomeError
 */
export const ActionOutcomeError = new ActionOutcomeError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionOutcomeCancelled$Type extends MessageType<ActionOutcomeCancelled> {
    constructor() {
        super("c1.api.policy.v1.ActionOutcomeCancelled", [
            { no: 1, name: "outcome_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionOutcomeCancelled
 */
export const ActionOutcomeCancelled = new ActionOutcomeCancelled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetAutomationInstance$Type extends MessageType<ActionTargetAutomationInstance> {
    constructor() {
        super("c1.api.policy.v1.ActionTargetAutomationInstance", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionTargetAutomationInstance
 */
export const ActionTargetAutomationInstance = new ActionTargetAutomationInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetBatonResourceActionInstance$Type extends MessageType<ActionTargetBatonResourceActionInstance> {
    constructor() {
        super("c1.api.policy.v1.ActionTargetBatonResourceActionInstance", [
            { no: 1, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionTargetBatonResourceActionInstance
 */
export const ActionTargetBatonResourceActionInstance = new ActionTargetBatonResourceActionInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProvisionPolicy$Type extends MessageType<ProvisionPolicy> {
    constructor() {
        super("c1.api.policy.v1.ProvisionPolicy", [
            { no: 100, name: "connector", kind: "message", oneof: "typ", T: () => ConnectorProvision },
            { no: 101, name: "manual", kind: "message", oneof: "typ", T: () => ManualProvision },
            { no: 102, name: "delegated", kind: "message", oneof: "typ", T: () => DelegatedProvision },
            { no: 103, name: "webhook", kind: "message", oneof: "typ", T: () => WebhookProvision },
            { no: 104, name: "multi_step", kind: "message", oneof: "typ", T: () => MultiStep },
            { no: 105, name: "external_ticket", kind: "message", oneof: "typ", T: () => ExternalTicketProvision },
            { no: 106, name: "unconfigured", kind: "message", oneof: "typ", T: () => UnconfiguredProvision },
            { no: 107, name: "action", kind: "message", oneof: "typ", T: () => ActionProvision }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ProvisionPolicy
 */
export const ProvisionPolicy = new ProvisionPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiStep$Type extends MessageType<MultiStep> {
    constructor() {
        super("c1.api.policy.v1.MultiStep", [
            { no: 1, name: "provision_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProvisionPolicy, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.MultiStep
 */
export const MultiStep = new MultiStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProvisionTarget$Type extends MessageType<ProvisionTarget> {
    constructor() {
        super("c1.api.policy.v1.ProvisionTarget", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "grant_duration", kind: "message", T: () => Duration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ProvisionTarget
 */
export const ProvisionTarget = new ProvisionTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision$Type extends MessageType<ConnectorProvision> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision", [
            { no: 1, name: "default_behavior", kind: "message", oneof: "provisionType", T: () => ConnectorProvision_DefaultBehavior },
            { no: 2, name: "account", kind: "message", oneof: "provisionType", T: () => ConnectorProvision_AccountProvision },
            { no: 3, name: "delete_account", kind: "message", oneof: "provisionType", T: () => ConnectorProvision_DeleteAccount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision
 */
export const ConnectorProvision = new ConnectorProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision_DefaultBehavior$Type extends MessageType<ConnectorProvision_DefaultBehavior> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision.DefaultBehavior", [
            { no: 1, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision.DefaultBehavior
 */
export const ConnectorProvision_DefaultBehavior = new ConnectorProvision_DefaultBehavior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision_DeleteAccount$Type extends MessageType<ConnectorProvision_DeleteAccount> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision.DeleteAccount", [
            { no: 1, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision.DeleteAccount
 */
export const ConnectorProvision_DeleteAccount = new ConnectorProvision_DeleteAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision_AccountProvision$Type extends MessageType<ConnectorProvision_AccountProvision> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision.AccountProvision", [
            { no: 1, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "config", kind: "message", T: () => Struct },
            { no: 4, name: "save_to_vault", kind: "message", oneof: "storageType", T: () => ConnectorProvision_SaveToVault },
            { no: 5, name: "do_not_save", kind: "message", oneof: "storageType", T: () => ConnectorProvision_DoNotSave }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision.AccountProvision
 */
export const ConnectorProvision_AccountProvision = new ConnectorProvision_AccountProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision_SaveToVault$Type extends MessageType<ConnectorProvision_SaveToVault> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision.SaveToVault", [
            { no: 1, name: "vault_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision.SaveToVault
 */
export const ConnectorProvision_SaveToVault = new ConnectorProvision_SaveToVault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProvision_DoNotSave$Type extends MessageType<ConnectorProvision_DoNotSave> {
    constructor() {
        super("c1.api.policy.v1.ConnectorProvision.DoNotSave", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ConnectorProvision.DoNotSave
 */
export const ConnectorProvision_DoNotSave = new ConnectorProvision_DoNotSave$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManualProvision$Type extends MessageType<ManualProvision> {
    constructor() {
        super("c1.api.policy.v1.ManualProvision", [
            { no: 1, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ManualProvision
 */
export const ManualProvision = new ManualProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegatedProvision$Type extends MessageType<DelegatedProvision> {
    constructor() {
        super("c1.api.policy.v1.DelegatedProvision", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "implicit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.DelegatedProvision
 */
export const DelegatedProvision = new DelegatedProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookProvision$Type extends MessageType<WebhookProvision> {
    constructor() {
        super("c1.api.policy.v1.WebhookProvision", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WebhookProvision
 */
export const WebhookProvision = new WebhookProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketProvision$Type extends MessageType<ExternalTicketProvision> {
    constructor() {
        super("c1.api.policy.v1.ExternalTicketProvision", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ExternalTicketProvision
 */
export const ExternalTicketProvision = new ExternalTicketProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnconfiguredProvision$Type extends MessageType<UnconfiguredProvision> {
    constructor() {
        super("c1.api.policy.v1.UnconfiguredProvision", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.UnconfiguredProvision
 */
export const UnconfiguredProvision = new UnconfiguredProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionProvision$Type extends MessageType<ActionProvision> {
    constructor() {
        super("c1.api.policy.v1.ActionProvision", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ActionProvision
 */
export const ActionProvision = new ActionProvision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Accept$Type extends MessageType<Accept> {
    constructor() {
        super("c1.api.policy.v1.Accept", [
            { no: 1, name: "accept_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Accept
 */
export const Accept = new Accept$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Reject$Type extends MessageType<Reject> {
    constructor() {
        super("c1.api.policy.v1.Reject", [
            { no: 1, name: "reject_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Reject
 */
export const Reject = new Reject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPoliciesRequest$Type extends MessageType<SearchPoliciesRequest> {
    constructor() {
        super("c1.api.policy.v1.SearchPoliciesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "policy_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.policy.v1.PolicyType", PolicyType, "POLICY_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { enum: { definedOnly: true } } } } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "exclude_policy_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.SearchPoliciesRequest
 */
export const SearchPoliciesRequest = new SearchPoliciesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPoliciesResponse$Type extends MessageType<SearchPoliciesResponse> {
    constructor() {
        super("c1.api.policy.v1.SearchPoliciesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Policy },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.SearchPoliciesResponse
 */
export const SearchPoliciesResponse = new SearchPoliciesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsedByRequest$Type extends MessageType<CountUsedByRequest> {
    constructor() {
        super("c1.api.policy.v1.CountUsedByRequest", [
            { no: 1, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CountUsedByRequest
 */
export const CountUsedByRequest = new CountUsedByRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsedByResponse$Type extends MessageType<CountUsedByResponse> {
    constructor() {
        super("c1.api.policy.v1.CountUsedByResponse", [
            { no: 1, name: "count_apps", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "count_app_entitlements", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "count_campaigns", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "count_campaign_templates", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CountUsedByResponse
 */
export const CountUsedByResponse = new CountUsedByResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProvisionInstance$Type extends MessageType<ProvisionInstance> {
    constructor() {
        super("c1.api.policy.v1.ProvisionInstance", [
            { no: 1, name: "provision", kind: "message", T: () => Provision },
            { no: 100, name: "completed", kind: "message", oneof: "outcome", T: () => CompletedAction },
            { no: 101, name: "cancelled", kind: "message", oneof: "outcome", T: () => CancelledAction },
            { no: 102, name: "errored", kind: "message", oneof: "outcome", T: () => ErroredAction },
            { no: 103, name: "reassigned_by_error", kind: "message", oneof: "outcome", T: () => ReassignedByErrorAction },
            { no: 104, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.ProvisionInstanceState", ProvisionInstanceState, "PROVISION_INSTANCE_STATE_"] },
            { no: 3, name: "notification_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ProvisionInstance
 */
export const ProvisionInstance = new ProvisionInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedAction$Type extends MessageType<CompletedAction> {
    constructor() {
        super("c1.api.policy.v1.CompletedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference },
            { no: 3, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CompletedAction
 */
export const CompletedAction = new CompletedAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelledAction$Type extends MessageType<CancelledAction> {
    constructor() {
        super("c1.api.policy.v1.CancelledAction", [
            { no: 1, name: "cancelled_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cancelled_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.CancelledAction
 */
export const CancelledAction = new CancelledAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ErroredAction$Type extends MessageType<ErroredAction> {
    constructor() {
        super("c1.api.policy.v1.ErroredAction", [
            { no: 1, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "errored_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ErroredAction
 */
export const ErroredAction = new ErroredAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptInstance$Type extends MessageType<AcceptInstance> {
    constructor() {
        super("c1.api.policy.v1.AcceptInstance", [
            { no: 1, name: "accept_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.AcceptInstance
 */
export const AcceptInstance = new AcceptInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectInstance$Type extends MessageType<RejectInstance> {
    constructor() {
        super("c1.api.policy.v1.RejectInstance", [
            { no: 1, name: "reject_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.RejectInstance
 */
export const RejectInstance = new RejectInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateRequest$Type extends MessageType<EditorValidateRequest> {
    constructor() {
        super("c1.api.policy.v1.EditorValidateRequest", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EditorValidateRequest
 */
export const EditorValidateRequest = new EditorValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateResponse$Type extends MessageType<EditorValidateResponse> {
    constructor() {
        super("c1.api.policy.v1.EditorValidateResponse", [
            { no: 1, name: "markers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EditorMarker }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EditorValidateResponse
 */
export const EditorValidateResponse = new EditorValidateResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.policy.v1.Policies
 */
export const Policies = new ServiceType("c1.api.policy.v1.Policies", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/policies", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Policy" }], group: "Policy" }] } }, I: CreatePolicyRequest, O: CreatePolicyResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/policies/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Policy", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Policy" }] } }, I: GetPolicyRequest, O: GetPolicyResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/policies/{policy.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Policy" }], group: "Policy" }] } }, I: UpdatePolicyRequest, O: UpdatePolicyResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/policies/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Policy" }], group: "Policy" }] } }, I: DeletePolicyRequest, O: DeletePolicyResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/policies", query: { page_size: "page_size", page_token: "page_token" }, group: "Policy" }] } }, I: ListPoliciesRequest, O: ListPolicyResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.policy.v1.PolicyValidate
 */
export const PolicyValidate = new ServiceType("c1.api.policy.v1.PolicyValidate", [
    { name: "ValidateCEL", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/policies/validate/cel", group: "Policy" }] } }, I: EditorValidateRequest, O: EditorValidateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.policy.v1.PolicySearch
 */
export const PolicySearch = new ServiceType("c1.api.policy.v1.PolicySearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/policies", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Policy", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Policies", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Policy", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: SearchPoliciesRequest, O: SearchPoliciesResponse },
    { name: "CountUsedBy", options: { "authz.method": { role: "VIEWER" } }, I: CountUsedByRequest, O: CountUsedByResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.policy.v1.AccountProvisionPolicyTest
 */
export const AccountProvisionPolicyTest = new ServiceType("c1.api.policy.v1.AccountProvisionPolicyTest", [
    { name: "Test", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/policies/test-account-provision-policy", group: "Policy" }] } }, I: TestAccountProvisionPolicyRequest, O: TestAccountProvisionPolicyResponse }
]);
